import { useCallback, useEffect, useState } from 'react';
import { BusinessesService } from 'service/businesses.service';
import { DealsService } from 'service/deals.service';

export type AutocompleteOption = { id: string; name: string };

export const useFetchAutocompleteDropdowns = () => {
  const [businesses, setBusinesses] = useState<AutocompleteOption[]>([]);
  const [clients, setClients] = useState<AutocompleteOption[]>([]);
  const [owners, setOwners] = useState<AutocompleteOption[]>([]);

  const fetchClients = useCallback(async (searchText?: string) => {
    try {
      const data = await DealsService.getAllClients(searchText);
      const formatted = data.clients.map((item: any) => ({
        id: item.AccountId,
        name: item.Name,
      }));
      setClients(formatted);
    } catch (error) {
      console.error('Failed to fetch clients', error);
      setClients([]);
    }
  }, []);

  const fetchBusinesses = useCallback(async () => {
    try {
      const data = await BusinessesService.getBusinesses();

      const formatted = data.businesses.map((item: any) => ({
        id: item.businessId,
        name: item.name,
      }));
      setBusinesses(formatted);
    } catch (error) {
      console.error('Failed to fetch businesses', error);
      setBusinesses([]);
    }
  }, []);

  const fetchOwners = useCallback(async () => {
    try {
      const data = await DealsService.getMembers();
      const formatted = data.map((item: any) => ({
        id: item.cognitoSub,
        name: `${item.firstName ?? ''} ${item.lastName ?? ''}`.trim(),
      }));
      setOwners(formatted);
    } catch (error) {
      console.error('Failed to fetch owners', error);
      setOwners([]);
    }
  }, []);

  useEffect(() => {
    fetchClients();
    fetchBusinesses();
    fetchOwners();
  }, [fetchClients, fetchBusinesses, fetchOwners]);

  return { businesses, clients, owners };
};
